import React, { Component, useEffect } from 'react';
import '../App.css';
import "aos/dist/aos.css";
import Aos from 'aos';
import telegram from '../assets/telegram.png';
import twitter from '../assets/twitter.png';
import discord from '../assets/discord.png';
import road from '../assets/road.png';

const x_link = () => {
    window.open("https://x.com/DiamondDaoNFT");
}

const discrd_link = () => {
    window.open("https://discord.gg/6apMxhJs");
}

const tg_link = () => {
    window.open("https://t.me/+76utqhODIgdmMWQ8");
}

const Stry = () => {
    useEffect(() => {
        Aos.init({ duration: 4000 });
    }, [])
}


class Footer extends Component {




    render() {
        return (

            <div class="boxWrap2Footer">

                <div class="footer">

                    <div class="icons">

                        <img id="icon1" onClick={x_link} src={twitter} />
                        <img id="icon2" onClick={discrd_link} src={discord} />
                        <img id="icon3" onClick={tg_link} src={telegram} />

                    </div>

                    <div class="copyright">Copyright © 2024 Diamond DAO. All Rights Reserved</div>

                    <div class="glitch-wrapper2">
                        <div class="glitch2" data-text="Diamond DAO" onClick={() => window.location.href = '/'}>Diamond DAO</div>
                    </div>
                </div>

                <img class="road" src={road} />

            </div>
        )
    }
}

export default Footer;

